import React from 'react';
import PropTypes from 'prop-types';
import ActionMenu from '../../ActionMenu';
import styles from './CellTypes.module.less';

const ActionCell = (props) => {
  const { original } = props.row;
  const { type, actions } = props.tableProps;

  return (
    <div className={styles.actionCell}>
      <ActionMenu titleHelper="Actions" title="Select action" data={original} type={type} actions={actions} />
    </div>
  );
};

ActionCell.propTypes = {
  row: PropTypes.object,
  tableProps: PropTypes.object,
};

export default ActionCell;
